import request from '@/utils/request';

function apiDownloadOrderAsPDF(ticketNumber) {
  return request({
    method: 'get',
    url: `storeOrderLine/DownloadOrderAsPDF`,
    params: {
      ticketNumber: ticketNumber
    }
  });
}

export const storeExtensions = {
  actions: {
    downloadOrderAsPDF({ commit, dispatch }, ticketNumber) {
      return new Promise((resolve, reject) =>
        apiDownloadOrderAsPDF(ticketNumber)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
